import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import SyrDevUaeForm from './components/landing/SyrDevUaeForm';
import AdminPanel from './components/admin/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './components/landing/LandingPage';
import AllEventsPage from './components/landing/AllEventsPage';
import { ADMIN_ROUTE } from './config/adminConfig';
import { AppBar, Toolbar, Button, Box, Typography } from '@mui/material';

import EventForm from './components/landing/EventForm';
import EventResponsesPage from './components/admin/EventResponsesPage';
import colors from './theme/colors';

// Create a custom theme for SyrDevUae
const theme = createTheme({
  palette: {
    primary: {
      main: colors.green,
      dark: colors.darkGreen,
      light: colors.lightGreen,
      contrastText: '#fff',
    },
    secondary: {
      main: colors.gray,
      dark: colors.darkGray,
      light: colors.gray,
      contrastText: '#fff',
    },
    background: {
      default: colors.lightBg,
      paper: colors.paper,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
    },
    warning: {
      main: colors.accent,
    },
    error: {
      main: colors.error,
    },
    success: {
      main: colors.success,
    },
    divider: colors.lightGray,
  },
  typography: {
    h3: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

function AppContent() {
  const location = useLocation();
  const isAdminPanel = location.pathname.startsWith(ADMIN_ROUTE);
  return (
    <>
      {!isAdminPanel && (
        <AppBar
          position="sticky"
          color="secondary"
          elevation={6}
          sx={{
            boxShadow: 10,
            zIndex: (theme) => theme.zIndex.drawer + 1,
            borderRadius: 0,
          }}
        >
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" component={Link} to="/" color="inherit" sx={{ textDecoration: 'none' }}>
                SyrDevUae
              </Typography>
            </Box>
            <Button color="inherit" component={Link} to="/join" sx={{ fontWeight: 700 }}>
              Join
            </Button>
          </Toolbar>
        </AppBar>
      )}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/join" element={<SyrDevUaeForm />} />
        <Route path="/events" element={<AllEventsPage />} />
        <Route path={ADMIN_ROUTE} element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        } />
        <Route path="/event/:eventId" element={<EventForm />} />
        <Route path="/admin/events/:eventId/responses" element={<EventResponsesPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
